import React, { useState } from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import LeadForm from '../../../components/forms/LeadForm';
import { LeadClient, LeadDTO, LeadFileDTO } from '../../../services/apiClient';
import { useNavigate } from 'react-router-dom';
import { API_BASE_URL } from '../../../config/config';
import axiosInstance from '../../../services/axiosInstance';
import { handleFileSubmit } from '../../../utils/leadUtils/handleFileSubmit';
import { handleNoteSubmit } from '../../../utils/leadUtils/handleNoteSubmit';
import Card from '../../../components/common/Card';

const LeadCreate: React.FC = () => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const navigate = useNavigate();
  const apiClient = new LeadClient(API_BASE_URL, axiosInstance);

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Leads', href: '/admin/leads' },
    { label: 'Create', href: '#' },
  ];

  const handleSubmit = async (data: LeadDTO, submitFiles: LeadFileDTO[], submitNotes: string[]) => {
    setIsSubmitting(true);
    try {
      var response = await apiClient.createLead(data);

      if (response && response.success) {
        await handleFileSubmit(response.data, submitFiles);
        if (submitNotes && submitNotes.length > 0) {
          await handleNoteSubmit(response.data?.id, submitNotes);
        }
        navigate('/admin/leads');
      }
    } catch (error) {
      console.error('Error creating Lead:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/leads"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Administrator', 'User']}
    >
      <Card title="Create Lead">
        <LeadForm
          initialValues={{} as LeadDTO}
          onSubmit={handleSubmit}
          onCancel={() => navigate('/admin/leads')}
        />
      </Card>
    </AdminLayout>
  );
};

export default LeadCreate;
